/* Design pass 2026-10-19: small behaviours that go with drippy-design-pass.css. */
(function () {
  var L = (document.documentElement.lang || 'en').slice(0, 2);
  var PICK = { en: 'Pick your size first', nl: 'Kies eerst je maat', de: 'Wähl zuerst deine Größe', fr: "Choisis d'abord ta taille", es: 'Elige primero tu talla', it: 'Scegli prima la tua taglia', pt: 'Escolhe primeiro o teu tamanho', sv: 'Välj din storlek först', da: 'Vælg din størrelse først' };

  /* Add to cart without a size: the theme shakes the size row; add a short line so people know why. */
  function sizeGroup() {
    return [].slice.call(document.querySelectorAll('.product__info-container .product-parameters .product-form__controls'))
      .filter(function (f) { return f.offsetParent && f.querySelector('.size-guide-btn') && f.querySelectorAll('input[type="radio"]').length > 1; })[0];
  }
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.product-form__submit, button[name="add"]');
    if (!b) return;
    var g = sizeGroup(); if (!g || g.querySelector('input[type="radio"]:checked')) return;
    if (g.querySelector('.dp-pick')) return;
    var head = g.querySelector('.product-form__group-name') || g.querySelector('legend') || g.firstElementChild;
    var s = document.createElement('span'); s.className = 'dp-pick'; s.setAttribute('role', 'alert'); s.textContent = PICK[L] || PICK.en;
    head.appendChild(s);
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') [].forEach.call(document.querySelectorAll('.dp-pick'), function (n) { n.remove(); });
  }, true);

  /* Menu: when the menu drawer opens, open "Shop by category" so the first view shows the categories.
     Watches the drawer itself (open attribute / class), so it works however the menu was opened. */
  function openCats() {
    var groups = document.querySelectorAll('details.dmenu__d');
    for (var i = 0; i < groups.length; i++) if (groups[i].open && groups[i].offsetParent) return;
    var panel = document.querySelector('[data-dmenu-panel]:not([hidden])') || document;
    var first = panel.querySelector('details.dmenu__d');
    if (first) first.open = true;
  }
  var drawer = document.querySelector('header-drawer details, details.menu-drawer-container');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () {
      if (drawer.hasAttribute('open') || drawer.classList.contains('menu-opening')) setTimeout(openCats, 30);
    }).observe(drawer, { attributes: true, attributeFilter: ['open', 'class'] });
  }

  /* Plain pages: the page text often repeats the page title as its first heading; hide that copy. */
  var pt = document.querySelector('.template-page .main-page-title');
  if (pt) {
    var first = document.querySelector('.template-page main .rte > :first-child');
    if (first && /^H[1-4]$/.test(first.tagName) && first.textContent.trim().toLowerCase() === pt.textContent.trim().toLowerCase()) first.classList.add('dp-dup');
  }

  /* Sticky bar steps aside while the reviews block's own Add to cart row is on screen (no two buttons at once). */
  var bar = document.querySelector('.product__popup');
  if (bar && 'IntersectionObserver' in window) {
    var hideFor = function (el) {
      new IntersectionObserver(function (es) {
        es.forEach(function (x) { bar.classList.toggle('dp-bar-off', x.isIntersecting); });
      }).observe(el);
    };
    var t = setInterval(function () { var a = document.querySelector('.rg__atc'); if (a) { clearInterval(t); hideFor(a); } }, 500);
    setTimeout(function () { clearInterval(t); }, 15000);
  }
})();

/* ===== Round 3 (20 Oct 2026) ===== */
(function () {
  var L = (document.documentElement.lang || 'en').slice(0, 2);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Back-in-stock sign-up: subscribe the picked size to Klaviyo's back-in-stock alert. */
  function info() {
    var id = document.querySelector('.product__info-container product-form input[name="id"]');
    var chk = [].slice.call(document.querySelectorAll('.product__info-container .product-parameters input[type="radio"]:checked'))
      .filter(function (r) { return !r.closest('.product__popup'); });
    var size = chk.map(function (r) { return r.value; }).filter(function (v) { return /\d/.test(v); })[0];
    if (size && size.indexOf(' / ') > -1) {
      var parts = size.split(' / '), inch = /^(US|GB|CA)$/.test((window.Shopify && Shopify.country) || '');
      size = parts.filter(function (x) { return inch ? /"|in/.test(x) : /cm|mm/.test(x); })[0] || parts[0];
    }
    return { id: id && id.value, size: size };
  }
  function fill(box) {
    var i = info(), name = i.size || box.dataset.title || '';
    var sub = box.querySelector('[data-dbis-sub]'); if (sub) sub.textContent = sub.dataset.t.replace('[size]', name);
    return { id: i.id, name: name };
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.notify-open-button')) setTimeout(function () { [].forEach.call(document.querySelectorAll('[data-dbis]'), fill); }, 50);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-dbis-form]'); if (!f || (f.closest('[data-dso]') && !f.dataset.vid)) return;
    e.preventDefault();
    var box = f.closest('[data-dbis]'), msg = box.querySelector('[data-dbis-msg]'), btn = f.querySelector('button');
    var em = f.email.value.trim(), it = f.dataset.vid ? { id: f.dataset.vid, name: f.dataset.vname } : fill(box);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) { f.email.focus(); return; }
    btn.disabled = true;
    var API = 'https://a.klaviyo.com/client/', Q = '/?company_id=NECnnY';
    var post = function (path, body) { return fetch(API + path + Q, { method: 'POST', headers: { 'content-type': 'application/vnd.api+json', 'revision': '2024-10-15' }, body: JSON.stringify(body) }).then(function (r) { return r.status; }, function () { return 0; }); };
    var loc = box.dataset.loc || 'KZG', lang = box.dataset.lang || 'en', shadow = it.id + '-' + loc;
    var ev = { data: { type: 'event', attributes: {
      properties: { VariantId: shadow, ShopifyVariantId: it.id, Location: loc, Country: box.dataset.country, Language: lang,
        ProductName: box.dataset.product, Handle: box.dataset.handle, Size: it.name, URL: location.origin + location.pathname },
      metric: { data: { type: 'metric', attributes: { name: 'Notify Me Requested' } } },
      profile: { data: { type: 'profile', attributes: { email: em, properties: { language: lang } } } } } } };
    var bis = { data: { type: 'back-in-stock-subscription', attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: em } } } },
      relationships: { variant: { data: { type: 'catalog-variant', id: '$custom:::$default:::' + shadow } } } } };
    post('events', ev).then(function (a) { return post('back-in-stock-subscriptions', bis).then(function (b) { return [a, b]; }); }).then(function (r) {
      // 404 on the subscription = the warehouse shadow size is not in Klaviyo yet; the event keeps the request for --replay
      if (r[0] !== 202 && r[1] !== 202) { msg.textContent = box.dataset.err; msg.className = 'dbis__msg'; msg.hidden = false; btn.disabled = false; return; }
      msg.textContent = box.dataset.ok.replace('[size]', it.name); msg.className = 'dbis__msg is-ok'; msg.hidden = false; f.hidden = true;
    });
  }, true);

  /* Sold-out size picked: hide the delivery promise. */
  var atc = document.querySelector('.product__info-container product-form [name="add"]');
  if (atc) {
    var info2 = atc.closest('.product__info-container');
    var sync = function () { info2.classList.toggle('dp-soldout', atc.disabled && !!document.querySelector('.product__info-container .product-parameters input[type="radio"]:checked')); };
    new MutationObserver(sync).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
    document.addEventListener('change', function () { setTimeout(sync, 60); }, true);
    sync();
  }

  /* Filter drawer: hide filters with only one choice; a black "show results" button that closes the drawer. */
  var SHOW = { nl: 'Toon resultaten', de: 'Ergebnisse anzeigen', fr: 'Voir les résultats', es: 'Ver resultados', it: 'Mostra risultati', pt: 'Ver resultados', sv: 'Visa resultat', da: 'Vis resultater', en: 'Show results' };
  function facets() {
    [].forEach.call(document.querySelectorAll('details.facets__disclosure'), function (d) {
      d.classList.toggle('dp-facet-one', d.querySelectorAll('.facets__list .facets__item').length === 1);
    });
    [].forEach.call(document.querySelectorAll('.facets-remove__all'), function (c) {
      if (c.parentElement.querySelector('.dp-show')) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'dp-show'; b.textContent = SHOW[L] || SHOW.en;
      b.addEventListener('click', function () {
        var w = b.closest('.facets__wrapper, .facets__container, menu-drawer, details') || document;
        var x = w.querySelector('.facets__close, [class*="close"], button[aria-label]');
        if (x) x.click(); else window.scrollTo({ top: 0 });
      });
      c.parentElement.insertBefore(b, c);
    });
  }
  facets();
  if (document.querySelector('#FacetFiltersForm') && window.MutationObserver) {
    var ft; new MutationObserver(function () { clearTimeout(ft); ft = setTimeout(facets, 150); }).observe(document.querySelector('#FacetFiltersForm').parentElement, { childList: true, subtree: true });
  }

  /* Empty cart: 4 bestsellers to tap straight into. */
  var bs = null;
  function bestsellers() {
    if (bs) return bs;
    bs = fetch(root + 'collections/best-sellers/products.json?limit=4').then(function (r) { return r.json(); }).then(function (j) {
      return Promise.all(j.products.slice(0, 4).map(function (p) { return fetch(root + 'products/' + p.handle + '.js').then(function (r) { return r.json(); }); }));
    });
    return bs;
  }
  function money(c) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'nl', { style: 'currency', currency: (window.Shopify && Shopify.currency.active) || 'EUR', maximumFractionDigits: c % 100 ? 2 : 0 }).format(c / 100); } catch (e) { return (c / 100).toFixed(2); }
  }
  function emptyCart() {
    var box = document.querySelector('cart-drawer.is-empty .drawer__inner-empty .top, cart-drawer.is-empty .drawer__inner-empty');
    if (!box || box.querySelector('.dp-empty')) return;
    var lab = document.querySelector('a[href*="/collections/best-sellers"]');
    var h = (lab && lab.textContent.trim()) || 'Bestsellers';
    var wrap = document.createElement('div'); wrap.className = 'dp-empty';
    wrap.innerHTML = '<p class="dp-empty__h"></p><div class="dp-empty__grid"></div>';
    wrap.firstChild.textContent = h;
    box.appendChild(wrap);
    bestsellers().then(function (ps) {
      var g = wrap.querySelector('.dp-empty__grid');
      ps.forEach(function (p) {
        var a = document.createElement('a'); a.className = 'dp-empty__card'; a.href = root + 'products/' + p.handle;
        var img = (p.featured_image || '').replace(/^\/\//, 'https://');
        a.innerHTML = '<span class="dp-empty__img"><img loading="lazy" alt="" src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=360"></span><span class="dp-empty__t"></span><span class="dp-empty__p"></span>';
        var nm = p.title.replace(/\.\s*-\s*/, ' ').replace(/\s+/g, ' ').trim().toLowerCase().replace(/(^|\s)(\S)/g, function (m, sp, c) { return sp + c.toUpperCase(); }).replace(/(\d)Mm\b/g, '$1mm').replace(/\b(\d+)k\b/gi, '$1K').replace(/\.$/, '');
        a.querySelector('.dp-empty__t').textContent = nm;
        a.querySelector('.dp-empty__p').textContent = money(p.price);
        g.appendChild(a);
      });
    }).catch(function () { wrap.remove(); });
  }
  var cd = document.querySelector('cart-drawer');
  if (cd && window.MutationObserver) {
    new MutationObserver(function () { if (cd.classList.contains('is-empty')) setTimeout(emptyCart, 50); }).observe(cd, { attributes: true, childList: true, subtree: true });
    if (cd.classList.contains('is-empty')) emptyCart();
  }
})();

/* ===== Round 4 (20 Oct 2026): whole product sold out. The notify popup gets its own size picker. ===== */
[].forEach.call(document.querySelectorAll('[data-dso]'), function (box) {
  var form = box.querySelector('[data-dbis-form]');
  var inch = /^(US|GB|CA)$/.test((window.Shopify && Shopify.country) || '');
  var h1 = document.querySelector('.product__title h1, .product__info-container h1');
  if (form.dataset.vid && h1) form.dataset.vname = h1.textContent.trim();
  function label(t) {
    if (t.indexOf(' / ') < 0) return t;
    var parts = t.split(' / ');
    return parts.filter(function (x) { return inch ? /"|in/.test(x) : /cm|mm/.test(x); })[0] || parts[0];
  }
  var chips = [].slice.call(box.querySelectorAll('.dso__size'));
  function pick(b) {
    chips.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
    form.dataset.vid = b.dataset.vid; form.dataset.vname = label(b.dataset.name);
    var h = box.querySelector('.dp-pick'); if (h) h.remove();
  }
  chips.forEach(function (b) { b.textContent = label(b.dataset.name); b.addEventListener('click', function () { pick(b); }); });
  /* Opening the popup: take over the size already tapped on the page, if any. */
  document.addEventListener('click', function (e) {
    if (!(e.target.closest && e.target.closest('.notify-open-button'))) return;
    var id = document.querySelector('.product__info-container product-form input[name="id"]');
    var chk = [].some.call(document.querySelectorAll('.product__info-container .product-parameters input[type="radio"]:checked'), function (r) { return /\d/.test(r.value); });
    var m = chk && id && chips.filter(function (b) { return b.dataset.vid === id.value; })[0];
    if (m) pick(m);
  }, true);
  /* No size picked yet: say so, and stop the sign-up. */
  document.addEventListener('submit', function (e) {
    if (e.target !== form || form.dataset.vid) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (!box.querySelector('.dp-pick')) {
      var p = document.createElement('p'); p.className = 'dp-pick'; p.textContent = box.dataset.pick;
      box.querySelector('.dso__sizes').after(p);
    }
  }, true);
});
